<template>
  <analytics-sub-page
    title="App Analytics"
    icon="mobile-screen-button"
    css-class="analytics-app"
    default-label="App"
    :section-specs="sectionSpecs"
  >
    <snapshot-metrics />
    <track-metrics ref="trackRef" />

    <!-- Build (Workplace Savings) -->
    <build-metrics v-if="isBuildEnabled" ref="buildRef" />
    <locked-metric-panel v-else-if="portalUpdatesJan2026Enabled" product-key="build" />

    <stream-metrics ref="streamRef" />

    <!-- Budget -->
    <budget-metrics v-if="isBudgetEnabled && portalUpdatesJan2026Enabled" ref="budgetRef" />
    <locked-metric-panel v-else-if="portalUpdatesJan2026Enabled" product-key="budget" />

    <!-- Rewards -->
    <rewards-metrics v-if="isRewardsEnabled && portalUpdatesJan2026Enabled" ref="rewardsRef" />
    <locked-metric-panel v-else-if="portalUpdatesJan2026Enabled" product-key="rewards" />

    <!-- SDL -->
    <sdl-metrics v-if="isSdlEnabled" ref="sdlRef" />
    <locked-metric-panel v-else-if="portalUpdatesJan2026Enabled" product-key="sdl" />

    <!-- Coach -->
    <coach-metrics v-if="isCoachEnabled && portalUpdatesJan2026Enabled" ref="coachRef" />
    <locked-metric-panel v-else-if="portalUpdatesJan2026Enabled" product-key="coach" />

    <coach-metrics-stub v-if="tescoPortalStubsEnabled" />
  </analytics-sub-page>
</template>

<script setup>
import { ref } from 'vue';
import AnalyticsSubPage from '@/components/AnalyticsSubPage.vue';
import BudgetMetrics from '@/pages/analyticsApp/components/BudgetMetrics.vue';
import BuildMetrics from '@/pages/analyticsApp/components/BuildMetrics.vue';
import CoachMetrics from '@/pages/analyticsApp/components/CoachMetrics.vue';
import CoachMetricsStub from '@/pages/analyticsApp/components/CoachMetricsStub.vue';
import LockedMetricPanel from '@/pages/analyticsApp/components/LockedMetricPanel.vue';
import RewardsMetrics from '@/pages/analyticsApp/components/RewardsMetrics.vue';
import SnapshotMetrics from '@/pages/analyticsApp/components/SnapshotMetrics.vue';
import StreamMetrics from '@/pages/analyticsApp/components/StreamMetrics.vue';
import TrackMetrics from '@/pages/analyticsApp/components/TrackMetrics.vue';
import SdlMetrics from '@/pages/analyticsApp/components/SdlMetrics.vue';
import useFeatureFlags from '@/composables/useFeatureFlags';
import useProductAvailability from '@/composables/useProductAvailability';

const { portalUpdatesJan2026Enabled, tescoPortalStubsEnabled } = useFeatureFlags();
const { isCoachEnabled, isBudgetEnabled, isRewardsEnabled, isSdlEnabled, isBuildEnabled } = useProductAvailability();

const trackRef = ref(null);
const buildRef = ref(null);
const streamRef = ref(null);
const budgetRef = ref(null);
const rewardsRef = ref(null);
const sdlRef = ref(null);
const coachRef = ref(null);

const sectionSpecs = [
  { key: 'track', label: 'Track', ref: trackRef },
  { key: 'savings', label: 'Savings', ref: buildRef },
  { key: 'pay', label: 'Pay', ref: streamRef },
  { key: 'budget', label: 'Budget', ref: budgetRef },
  { key: 'rewards', label: 'Rewards', ref: rewardsRef },
  { key: 'loans', label: 'Loans', ref: sdlRef },
  { key: 'coach', label: 'Coach', ref: coachRef },
];
</script>
